import { useEffect, useState } from "react";
import { AiFillBackward } from "react-icons/ai";
import { CiCircleRemove } from "react-icons/ci";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useGetDealersQuery } from "../../features/api/dealerApi";
import { useGetCategoryQuery } from "../../features/api/categoryApi";
import { useGetProductQuery } from "../../features/api/productApi";
import {
  useAddQuotationMutation,
  useGetQuotationsQuery,
} from "../../features/api/quotationmainApi";
import { useGetSubCategoryQuery } from "../../features/api/subcategoryApi";
import { useGetAllModelQuery } from "../../features/api/modelApi";
import AddSubCategory from "../CategoryManagement/SubCategory/AddSubCategory";
import AddProduct from "../CategoryManagement/Product/AddProduct";
import CrateUnit from "../CategoryManagement/Unit/CrateUnit";
import NewDealer from "../Sales/SalesProduct/NewDealer";
import { API_BASE_URL } from "../../components/baseUrl";

const CreateQuotation = () => {
  const [selectedProductModel, setSelectectedProductModel] = useState("");
  const [qto_sub, setSubject] = useState("");
  const [qto_term, setTermCondition] = useState("");
  const [inv_date, setInvDate] = useState("");
  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0];
    setInvDate(currentDate);
  }, []);
  const [cat_name, setCategory] = useState(91);
  const [sub_catName, setSubCategory] = useState("");
  const [pro_name, setProduct] = useState("");

  // fetch all dealer
  const dealers = useGetDealersQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.dealer;

  // fetch all categories
  const categories = useGetCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.categories;

  const subCategory = useGetSubCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.brandData;

  const products = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;

  const productModels = useGetAllModelQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;

  const quotations = useGetQuotationsQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.quotation_mains;

  let maxInvNo = 0;
  quotations?.map((data) => {
    const invNo = data?.qto_no;
    const invSeperate = invNo?.split("-")[1];
    // const generateAgain = invSeperate?.split("/")[0];
    if (!isNaN(invSeperate) && +invSeperate > +maxInvNo) {
      maxInvNo = invSeperate;
    }
  });
  const generateInvoice = ` QT-${+maxInvNo + 1}`;

  // filter dealer previous dues
  const [dealer, setDealerName] = useState("");

  const [transaction, setTransaction] = useState([]);
  useEffect(() => {
    const fetchTransaction = async () => {
      const response = await axios.get(
        `${API_BASE_URL}/api/TransactionQuery?ledger_id=1&tag_ac_id=${dealer}`
      );
      setTransaction(response?.data?.transactions);
    };
    fetchTransaction();
  }, [dealer]);

  let balance = 0;
  transaction?.map((data) => {
    const { dabit_amount, credit_amount } = data;
    balance += dabit_amount - credit_amount;
    return balance;
  });

  const [createNewQuotation] = useAddQuotationMutation();

  const user = JSON.parse(localStorage.getItem("user"));

  const encodedProductName = encodeURIComponent(pro_name);
  const apiUrl = `${API_BASE_URL}/api/salesRatebyproname?proName=${encodedProductName}`;

  const [vat, setVat] = useState(0);
  const [discount, setDiscount] = useState(0);

  // fetch Brand by category name
  const [subCatByCat, setSubCatByCat] = useState([]);
  const [relode, setRelode] = useState(false);
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/sub-categories/${cat_name}`)
      .then((res) => res.json())
      .then((data) => {
        setSubCatByCat(data?.subCategory);
        setRelode(!relode);
      });
  }, [cat_name]);

  // fetch product by Brand name
  const [getProductBySubCat, setGetProductBySubCat] = useState([]);
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/subCatProducts?subCategory=${sub_catName}`)
      .then((res) => res.json())
      .then((data) => {
        setGetProductBySubCat(data?.product);
        setRelode(!relode);
      });
  }, [sub_catName]);

  // for save multiple purchase data
  const [newArray, setNewArray] = useState([]);
  const handleAddItem = () => {
    if (dealer === "") {
      toast.error("Client must required");
    } else {
      setNewArray([
        ...newArray,
        {
          qto_no: generateInvoice,
          qto_date: inv_date,
          sub_cat: sub_catName,
          pro_name: pro_name,
          despt: "",
          qty: 1,
          sales_rate: 0,
          total: 0,
        },
      ]);
    }
  };

  // handle quantity for individual product
  const handleQuantityChange = (index, qty) => {
    const updatedData = [...newArray];
    updatedData[index].qty = qty;
    updatedData[index].total = qty * updatedData[index].sales_rate;
    setNewArray(updatedData);
  };

  // handle description for individual product
  const handleDescChange = (index, desc) => {
    const updatedData = [...newArray];
    updatedData[index].despt = desc;
    setNewArray(updatedData);
  };

  // handle quantity for individual product
  const handleRateChange = (index, rate) => {
    const updatedData = [...newArray];
    updatedData[index].sales_rate = rate;
    updatedData[index].total = rate * updatedData[index].qty;
    setNewArray(updatedData);
  };

  const subTotal = newArray?.reduce((sum, item) => sum + item.total, 0);
  const vatAmount = subTotal * (vat / 100);
  const totalAmounts = subTotal + vatAmount;
  const totalSalesAmt = totalAmounts - discount;
  const grandTotal = totalAmounts + balance - discount;

  // remove from product list before purchase
  const handleRemove = (index) => {
    const restProduct = [...newArray];
    restProduct.splice(index, 1);
    setNewArray(restProduct);
  };

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // handle function for purchase product

  const handleOrder = async () => {
    setLoading(true);
    const data2 = {
      qto_no: generateInvoice,
      qto_date: inv_date,
      client: dealer,
      qto_sub,
      qto_term,
      total: subTotal,
      vat: vatAmount,
      discount: discount,
      grand_total: totalSalesAmt,
      created_by: user?.role,
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/quotation`,
        newArray
      );

      if (response?.data) {
        await createNewQuotation(data2);
        setLoading(false);
        navigate("/dashboard/quotation");
        // toast.success('success')
      } else if (response?.error) {
        setLoading(false);
        toast.error("Fetching error");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error updating data:", error?.response);
    }
  };

  return (
    <div className=" bg-slate-200">
      <div className="flex justify-between items-center p-2">
        <h1 className="text-xl font-medium">Create Quotation</h1>
        <div className="flex items-center gap-x-2">
          <AddSubCategory />
          <AddProduct />
          <CrateUnit />
          <NewDealer />
          <Link
            to="/dashboard/quotation"
            className="bg-blue-500 px-2 py-1 rounded text-white flex items-center gap-x-1"
          >
            <AiFillBackward /> Back{" "}
          </Link>
        </div>
      </div>
      <div className="">
        <div className="p-2 m-2 border">
          <form className=" ">
            <div className="flex w-full flex-wrap gap-2">
              <div className="flex flex-col gap-1 w-[15%]">
                <label className="font-medium">Quotation No.</label>
                <input
                  type="text"
                  value={generateInvoice}
                  disabled
                  className="border h-8 pl-1 bg-slate-50"
                />
              </div>
              <div className="flex flex-col gap-1 w-[30%]">
                <label className="font-medium">Quotation Date</label>
                {/* <DateTimePicker
                  value={inv_date}
                  onChange={setInvDate}
                  className="bg-slate-50 h-8"
                /> */}
                <input
                  type="date"
                  value={inv_date}
                  onChange={(e) => setInvDate(e.target.value)}
                  className="border h-8 pl-1 bg-slate-50"
                />
              </div>
              <div className="flex flex-col gap-1 w-[53%]">
                <label className="font-medium">Client Name</label>
                <select
                  onChange={(e) => setDealerName(e.target.value)}
                  className="border h-8 p-1 bg-slate-50"
                >
                  <option>--select--</option>
                  {dealers?.map((dealer) => (
                    <option key={dealer?.id} value={dealer?.id} className="">
                      {dealer?.d_name} - {dealer?.d_mobile}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="flex justify-between flex-wrap gap- my-3 w-full">
              <div className="flex flex-col gap-1 w-[25%]">
                <label className="font-medium">Category</label>
                <select
                  onChange={(e) => setCategory(e.target.value)}
                  className="border h-8 pl-1 bg-slate-50"
                >
                  <option>--select--</option>
                  {categories?.map((cat) => (
                    <option key={cat?.id} value={cat?.id}>
                      {cat?.cat_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex flex-col gap-1 w-[25%]">
                <label className="font-medium">Brand</label>
                <select
                  onChange={(e) => setSubCategory(e.target.value)}
                  className="border h-8 pl-1 bg-slate-50"
                >
                  <option>--select--</option>
                  {subCategory
                    ?.filter((item) => item?.cat_name == cat_name)
                    ?.map((sCat) => (
                      <option key={sCat?.id} value={sCat?.id}>
                        {sCat?.sub_catName}
                      </option>
                    ))}
                </select>
              </div>
              <div className="flex flex-col gap-1 w-[25%]">
                <label className="font-medium">Product</label>
                <select
                  onChange={(e) => setProduct(e.target.value)}
                  className="border h-8 pl-1 bg-slate-50"
                >
                  <option>--select--</option>
                  {products
                    ?.filter((item) => item?.sub_catName == sub_catName)
                    ?.map((product) => (
                      <option key={product?.id} value={product?.id}>
                        {product?.product_name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="flex flex-col gap-1 w-[25%]">
                <label className="font-medium">Product Models</label>
                <select
                  onChange={(e) => {
                    setSelectectedProductModel(Number(e.target.value));
                  }}
                  className="border h-8 pl-1 bg-slate-50"
                >
                  <option>--select--</option>
                  {productModels
                    ?.filter((model) => model.product_id === +pro_name)
                    .map((model) => (
                      <option key={model?.model_id} value={model?.model_id}>
                        {model?.model_name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </form>
          <div className="mt-2 flex flex-col gap-y-2">
            <div className="flex flex-col gap-1">
              <label className="font-bold">Subject</label>
              <textarea
                onChange={(e) => setSubject(e.target.value)}
                rows={2}
                className="focus:outline-none p-1 border bg-slate-50"
              />
            </div>
          </div>
          <button
            onClick={() => handleAddItem()}
            // disabled={inv_date === "" || dealer === ""}
            className="bg-blue-500 px-4 py-1 text-white font-bold block mx-auto mt-4"
          >
            Add Product
          </button>
        </div>
        <div className="p-2 m-2 border mx-auto overflow-auto">
          <table className=" bg-white w-full">
            <thead>
              <tr>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                  Product Name
                </th>
                <th className="px-6 py-3 w-[300px] border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                  Description
                </th>
                <th className="px-6 py-3 w-[130px] border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                  Sales Rate
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                  Quantity
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                  Total Amount
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="">
              {newArray?.map((data, index) => {
                const proName = products?.find(
                  (pro) => pro?.id === +data?.pro_name
                );
                return (
                  <tr key={index}>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      {proName?.product_name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      <textarea
                        onChange={(e) =>
                          handleDescChange(index, e.target.value)
                        }
                        className="border w-[300px] focus:outline-none text-sm h-12 "
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      <input
                        type="number"
                        defaultValue={data?.sales_rate}
                        onChange={(e) =>
                          handleRateChange(index, e.target.value)
                        }
                        className="border focus:outline-none w-[130px]"
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      <input
                        onChange={(e) =>
                          handleQuantityChange(index, e.target.value)
                        }
                        type="number"
                        defaultValue={data?.qty}
                        className="border pl-1 w-16 focus:outline-none"
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      {data?.total}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      <button
                        onClick={() => handleRemove(index)}
                        className="text-xl text-white bg-red-500 rounded-full"
                      >
                        <CiCircleRemove />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <thead className="text-sm">
              <tr className="">
                <th
                  colSpan={4}
                  className="px-6 py-3 border-b-2 font-bold text-xs border-gray-300 text-right uppercase tracking-wider"
                >
                  Total:
                </th>
                <th
                  // colSpan={}
                  className="px-6 py-3 border-b-2 border-gray-300 text-left font-bold text-xs uppercase tracking-wider"
                >
                  <p className="border w-24 p-1 text-xs"> {subTotal}</p>
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left font-bold text-xs uppercase tracking-wider"></th>
              </tr>
            </thead>
          </table>
          <div className="flex flex-col gap-1 mt-4">
            <label className="font-bold">Terms & Condition</label>
            <textarea
              onChange={(e) => setTermCondition(e.target.value)}
              rows={2}
              className="focus:outline-none p-1 border"
            />
          </div>
          <button
            onClick={() => handleOrder()}
            className={`bg-green-500 px-4 py-1 text-white font-bold  mt-4 `}
          >
            {loading ? "Loading..." : "Submit"}
            {/* <Link to="/dashboard/order/invoice" state={passData}>Submit</Link> */}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateQuotation;
